
import React from "react";

import CleanUpLogs from "../component/CleanUpLogs";

const CleanUpLogsContainer = () => (<CleanUpLogs />)

export default CleanUpLogsContainer; 